import React, { useState } from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Text from '../../../components/typography'
import { theme } from '../../../themes/default-theme';
import Modal from '../../../components/ui/Modal';
import { FacebookShareButton, FacebookIcon } from "react-share";

const ShareSocialContainer = styled.div`
    text-align: center;
    ${theme.breakpoints.up('md')} {
        h4 {
            margin-bottom: 19px;
            font-size: 20px;
            + div {
                margin-bottom: 29px;
                max-width: 400px;
                margin-left: auto;
                margin-right: auto;
            }
        }
        h5 {
            font-size: 15px;
            line-height: 21px;
        }
    }
    ${theme.breakpoints.down('sm')} {
        h4 {
            margin-bottom: 15px;
            font-size: 16px;
            + div {
                margin-bottom: 15px;
            }
        }
        h5 {
            font-size: 14px;
            line-height: 21px;
        }
    }
`

const ShareInput = styled(TextField)`
  width: 100%;
  fieldset {
    border-color: ${theme.palette.middleGrey}!important;
  }
  ${theme.breakpoints.up('md')} {
    margin: 19px 0;
  }

  ${theme.breakpoints.down('sm')} {
    margin: 15px 0;
  }
`

const Facebook = styled(FacebookIcon)`
  border-radius: 80px;
  border: 1px solid ${theme.palette.vividBlue};
  & path {
     fill: ${theme.palette.vividBlue};
  }
  & rect {
    fill: none;
  }
  ${theme.breakpoints.up('md')} {
    margin-top: 19px;
  }

  ${theme.breakpoints.down('sm')} {
    margin-top: 15px;
  }
`
const InputContainer = styled.div`
  position: relative;
  a {
        color: ${theme.palette.vividBlue};
        font-weight: 700;
        line-height: 21px;
        text-transform: uppercase;
        position: absolute;
        top: 50%;
        transform: translat);
        transform: translateY(-50%);
        right: 19px;
        cursor: pointer;
  }
  ${theme.breakpoints.up('md')} {
    a {
        font-size: 15px;
    }
    input {
        padding-right: 73px;
    }
  }
  ${theme.breakpoints.down('sm')} {
    a {
        font-size: 14px;
    }
    input {
        padding-right: 65px;
    }
  }
`

const newModelSharePopupDefaultPropShareStatus = () => { };

const NewModelSharePopup = (props) => {
    props = {
        ...props,
        shareStatus: typeof props.shareStatus === "undefined" ? newModelSharePopupDefaultPropShareStatus : props.shareStatus,
        buildUrl: typeof props.buildUrl === "undefined" ? null : props.buildUrl
    };

    const {
        shareStatus,
        buildUrl
    } = props

    const [open, setOpen] = useState(true);

    const useStyles = makeStyles(() => ({
        modalOverlay: {
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
                paddingRight: 0,
            }
        },
        content: {
            position: 'relative',
            zIndex: 1001,
            display: 'inline-block',
            verticalAlign: 'middle',
            width: '100%',
            maxWidth: '544px',
            margin: 'auto',
            background: '#F3F4F7',
            [theme.breakpoints.up('md')]: {
                padding: '37px 46px'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '20px'
            }
        },
        modalInner: {
            width: '100%',
            display: 'inline-block',
            maxWidth: 1254,
        },
        modalClose: {
            top: '20px',
            right: '20px',
            position: 'fixed',

        }
    }));

    const classes = useStyles();

    return (

        <Modal
            isOpen={open}
            onClose={() => {
                setOpen(false);
                shareStatus();
            }
            }
            overlayClassname={classes.modalOverlay}
            innerClassname={classes.modalInner}
            closeClassname={classes.modalClose}
            contentClassname={classes.content}
            backdropBackground={'rgba(46, 50, 56, 0.8)'}
            iconVividBlue={true}
        >
            <ShareSocialContainer>
                <Text variant="h4" weight={800} alignItems={'flex-start'} uppercase>Share</Text>
                <Text variant="body1" alignItems={'flex-start'}>Share your new Jayco build via a dedicated URL or post to social media</Text>
                <Text variant="h5" weight={700} alignItems={'flex-start'} uppercase>Build Url</Text>
                <InputContainer>
                    <ShareInput
                        placeholder={''}
                        value={buildUrl}
                        variant="outlined"
                        disabled
                    />
                    <a onClick={() => {
                        navigator.clipboard.writeText(buildUrl);
                    }}>
                        Copy
                    </a>
                </InputContainer>
                <Text variant="h5" weight={700} alignItems={'flex-start'} uppercase>Or post to</Text>
                <FacebookShareButton url={global.location}>
                    <Facebook size={38} />
                </FacebookShareButton>
            </ShareSocialContainer>
        </Modal>

    )
}

NewModelSharePopup.propTypes = {
    shareStatus: propTypes.func,
    buildUrl: propTypes.string
}

export default NewModelSharePopup
